import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SwUpdate } from '@angular/service-worker';
import { TabService } from './tab.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {

  dialogRef: any = null;

  constructor(public updates: SwUpdate, private dialog: MatDialog, public tabService: TabService, private _snackBar: MatSnackBar) {
    console.log('SwUpdate isEnabled:'+updates.isEnabled)
    console.log(updates.isEnabled)

    updates.available.subscribe(event => {
      console.log('A newer version is now available');
      this.promptUser()
    })
    
  }

  private promptUser(): void {
    this.updates.activateUpdate().then(() => 
      {

        let snackBarRef = this._snackBar.open("已發現新版本！請刷新頁面以使用最新版本。", "刷新", {
          verticalPosition: 'top'
        });
  
        snackBarRef.onAction().subscribe(() => {
          document.location.reload();
        });
      }
    ); 
  }
}
